/* eslint-disable no-unused-vars */
import i18n from '@/js/plugins/i18n';
import img from '../img/progress2step.svg';

export default {
  id: 'progress2step',
  img,
  imgBg: 'linear-gradient(to right, #C7F9C5 0%, #C7F9C5 50%, #E6DAFF 50%, #E6DAFF 100%)',
  defaultConf() {
    return {
      stepLabel: i18n.global.t('KANBAN.VALIDATED'),
    };
  },
  canRun({ planning, element, oldData, newData, automation }) {
    const oldProgress = parseInt(oldData.progress, 10) || 0;
    const newProgress = parseInt(newData.progress, 10) || 0;
    if (oldProgress === 100 || newProgress !== 100) return false;
    return true;
  },
  run({ planning, element, oldData, newData, automation }, showToast) {
    const targetLabel = (automation.conf.stepLabel || '').trim();
    const targetStep = targetLabel && planning.process?.steps?.find(step => step.label === targetLabel);
    if (! targetStep?.id || element.getProcessStep() == targetStep.id) return;

    if (showToast) showToast();
    element.setProcessStep(targetStep.id);
  },
};
